module.exports = __webpack_public_path__ + "static/img/graph_image_type0.ae9e53d5.png";